import { render, staticRenderFns } from "./coin-swap-info-manag.vue?vue&type=template&id=21bb412e&"
import script from "./coin-swap-info-manag.vue?vue&type=script&lang=js&"
export * from "./coin-swap-info-manag.vue?vue&type=script&lang=js&"
import style0 from "./coin-swap-info-manag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports